<template>
<div>
        <p>Payment products allow you to interact with our payment APIs.</p>
 

<b-card>
    <!-- input search -->
    <div class="custom-search d-flex justify-content-end">
        <b-form-group>
            <div class="d-flex align-items-center">
                <label class="mr-1">Search</label>
                <b-form-input v-model="searchTerm" placeholder="Search" type="text" class="d-inline-block" />
            </div>
        </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table :columns="columns" :rows="rows" :rtl="direction" :search-options="{
        enabled: true,
        externalQuery: searchTerm }" :pagination-options="{
        enabled: true,
        perPage:pageLength
      }">
        <template slot="table-row" slot-scope="props">
            <!-- Column: Status -->
            <span v-if="props.column.field === 'status'">
                <b-badge :variant="statusVariant(props.row.status)">
                    {{ props.row.status }}
                </b-badge>
            </span>

            <!-- Column: Action -->
            <span v-else-if="props.column.field === 'action'">
                <span>
                    <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                        <template v-slot:button-content>
                            <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                        </template>
                        <b-dropdown-item>
                            <feather-icon icon="Edit2Icon" class="mr-50" />
                            <span>Disabled</span>
                        </b-dropdown-item>
                        <b-dropdown-item>
                            <feather-icon icon="TrashIcon" class="mr-50" />
                            <span>Delete</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </span>
            </span>

            <!-- Column: Common -->
            <span v-else>
                {{ props.formattedRow[props.column.field] }}
            </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap">
                        Showing 1 to
                    </span>
                    <b-form-select v-model="pageLength" :options="['3','5','10']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                    <span class="text-nowrap "> of {{ props.total }} entries </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value)=>props.pageChanged({currentPage:value})">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</b-card>
</div>
</template>

<script>
import {
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard
} from 'bootstrap-vue'
import {
    VueGoodTable
} from 'vue-good-table'
import store from '@/store/index'

export default {
    components: {
        VueGoodTable,
        BAvatar,
        BBadge,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
        BCard
    },
    data() {
        return {
            pageLength: 3,
            dir: false,
            columns: [{
                    label: 'Product',
                    field: 'product',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Search Service Products',
                    },
                },
                {
                    label: 'Product Type',
                    field: 'type',
                },
                {
                    label: 'Callback URL',
                    field: 'callbackUrl',
                },
                 {
                    label: 'Channels',
                    field: 'channel',
                },
                {
                    label: 'Status',
                    field: 'status',
                },

                {
                    label: 'Action',
                    field: 'action',
                },
            ],
            rows: [{
                    product: "50231",
                    type: 'Paybill C2B',
                    callbackUrl: 'www.ussd.fleek.io',
                    channel:"Safaricom",
                    status:"Active"
                },
                {
                   product: "40231",
                    type: 'Paybill C2B',
                    callbackUrl: 'www.ussd.fleek.io',
                    channel:"Safaricom",
                    status:"Disabled"
                },
                {
                   product: "60271",
                    type: 'Paybill C2B',
                    callbackUrl: 'www.ussd.fleek.io',
                    channel:"Safaricom",
                    status:"Active"
                },
            ],
            searchTerm: '',
            status: [
            {
                1: 'Active',
                2: 'Pending',
                3: 'Rejected',
            }, {
                1: 'light-success',
                2: 'light-primary',
                3: 'light-danger',
            }],
        }
    },
    computed: {
        statusVariant() {
            const statusColor = {
                /* eslint-disable key-spacing */
                Active: 'light-success',
                Pending: 'light-primary',
                Rejected: 'light-danger',
                /* eslint-enable key-spacing */
            }

            return status => statusColor[status]
        },
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },
   
}
</script>
